export const StorageKeys = {
	BaseListSettings: 'base-list-settings',
};
